import { Contrato } from './contrato.entity';
import { UsuarioOnline } from './UsuarioOnline.entity';
export class Domiciliacion
    {
        UsuarioOnline: UsuarioOnline;
        Contrato: Contrato;
        TipoSolicitud: string;
        Poblacion: string;
    }